// Rather than refactoring our model.ts file to support JSX, we'll rely on this simple wrapper function.
import React from 'react';

// External to ShopKeeper types
import { modal } from '../../../modal/ModalEmitter';
import PaymentSaleForm from '../../../payment/PaymentSaleForm';
import PaymentCreditForm from '../../../payment/PaymentCreditForm';
import { PaymentSessionCancelResponse, PaymentSessionSuccessResponse } from '../../../payment/types';

/* Note both onCancel and onSuccess purposefully do not consider payment session API errors before applying
   the appropriate action to QM.  There's no reason to hold up inventory if there's a bug marking a session
   canceled or complete.
*/
export const launchPaymentSession = ({
  amount,
  customerNum,
  invoiceNum,
  onCancel,
  onResumeLater,
  onSuccess,
  ppc,
  printerId,
}: {
  amount: number;
  customerNum: string;
  invoiceNum: string;
  onCancel: (response: PaymentSessionCancelResponse) => void;
  onResumeLater: () => void;
  onSuccess: (response: PaymentSessionSuccessResponse) => void;
  ppc: string;
  printerId: string;
}) => {
  modal.open({
    title: 'Terminal Transaction',
    closeButton: false,
    hidePrint: true,
    hideFooter: true,
    staticBackdrop: true,
    size: 'md',
    message: (
      <PaymentSaleForm
        amount={amount}
        cashInvoicePrinterId={printerId}
        customerNum={customerNum}
        department="parts"
        invoiceNum={invoiceNum}
        onCancel={onCancel}
        onResumeLater={onResumeLater}
        onSuccess={onSuccess}
        userInitials={ppc}
      />
    ),
  });
};

export const launchCreditSession = ({
  amount,
  customerNum,
  creditInvoiceNum,
  originalInvoiceNum,
  onCancel,
  onResumeLater,
  onSuccess,
  ppc,
  printerId,
}: {
  amount: number;
  customerNum: string;
  creditInvoiceNum: string;
  originalInvoiceNum: string;
  onCancel: (response: PaymentSessionCancelResponse) => void;
  onResumeLater: () => void;
  onSuccess: (response: PaymentSessionSuccessResponse) => void;
  ppc: string;
  printerId: string;
}) => {
  modal.open({
    title: 'Credit Payment Transaction',
    size: 'md',
    closeButton: false,
    hideFooter: true,
    hidePrint: true,
    staticBackdrop: true,
    headerClass: 'primary',
    message: (
      <PaymentCreditForm
        amount={amount}
        cashInvoicePrinterId={printerId}
        invoiceNum={creditInvoiceNum}
        originalInvoiceNum={originalInvoiceNum}
        customerNum={customerNum}
        department="parts"
        onCancel={onCancel}
        onResumeLater={onResumeLater}
        onSuccess={onSuccess}
        userInitials={ppc}
      />
    ),
  });
};
